import { getCheckPrice, selectBasketCheckPriceItem, selectBasketIsReservationUnlocked, selectBasketItem, selectBasketRedirect, selectBasketSelectedWarehouses } from 'containers/OrderDetails/basketSlice'
import { Prompt, useHistory, useParams } from 'react-router-dom'
import { useReduxDispatch, useReduxSelector } from 'store'
import { selectUserId } from 'containers/Login/loginSlice'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import ArrowBtn from 'components/buttons/ArrowBtn'
import Locks from 'containers/OrderDetails/Locks'
import useTranslation from 'hooks/useTranslation'
import PeriodsToPay from './PeriodsToPay'
import { useEffect, useRef } from 'react'
import Loading from 'components/Loading'
import { selectConfig } from 'appSlice'
import Error from 'components/Error'
import Equipment from './Equipment'
import Discounts from './Discounts'
import Insurance from './Insurance'
import Calendar from './Calendar'
import Summary from './Summary'
import Shop from './Shop'
import './style.scss'

const OrderDetails = ({ isDesktop = false }) => {
  const { id } = useParams<{ id: string }>()
  const config = useReduxSelector(selectConfig)
  const clientId = useReduxSelector(selectUserId)
  const redirect = useReduxSelector(state => selectBasketRedirect(state, id))
  const selectedWarehouses = useReduxSelector(selectBasketSelectedWarehouses)
  const isBasketUnlocked = useReduxSelector(selectBasketIsReservationUnlocked)
  const checkPrice = useReduxSelector(state => selectBasketCheckPriceItem(state, id))

  const { t } = useTranslation()
  const reduxDispatch = useReduxDispatch()
  const { push, goBack, replace } = useHistory()

  const validateLocks = useRef<() => boolean>(null)

  const thereAreLocksAvailable = (!!checkPrice?.lock?.openingMethods && checkPrice?.lock.openingMethods.length > 0)
    || (!!checkPrice?.placeLock?.openingMethods && checkPrice?.placeLock.openingMethods.length > 0)

  useEffect(() => {
    if (selectedWarehouses.length > 0) {
      reduxDispatch(getCheckPrice())
    }
  }, [clientId, reduxDispatch, selectedWarehouses])

  useEffect(() => {
    const basket = document.querySelector('#basket_container_id')
    basket?.scrollTo({ top: 0, behavior: 'smooth' })
  }, [id])

  useEffect(() => {
    if (redirect === -1) goBack()
    if (redirect && typeof redirect === 'string') replace(redirect)
  }, [goBack, redirect, replace])

  const summary = <>
    <Summary />
    <div className='orderInfo__buttons'>
      <ArrowBtn
        enlarged
        text={t('basic.next')}
        action={() => {
          if (validateLocks.current?.()) {
            push(window.location.pathname, LOCATION_STATES.popup('basket'))
          }
        }}
      />
    </div>
  </>

  return (
    <>
      <Prompt
        message={({ pathname, state }) => {
          const regex = isBasketUnlocked ? /(?=.*(map|order|login|registration|contract|mapdetails|placemap|shop))/ : /(?=.*(map|order|login|registration|contract|shop))(?!.*mapdetails)/
          const isUnlocked = state && typeof state === 'object' && 'unlock' in state ? state.unlock : undefined
          return (isUnlocked || pathname.match(regex)) ? true : t('calendar.areYouSure')
        }}
      />
      <div className={`orderInfo ${isDesktop ? '--desktop' : ''}`}>
        {checkPrice?.status === STATUS.succeed
          ? <>
            <Calendar isDesktop={isDesktop} />
            {(config?.warehouseAccessoriesEnabled && checkPrice?.equipment?.length > 0) && <Equipment />}
            {checkPrice?.insurance && <Insurance />}
            {config?.storeEnabled && <Shop />}
            {thereAreLocksAvailable && <Locks ref={validateLocks} />}
            <div className='orderInfo__row'>
              <PeriodsToPay />
              <Discounts />
            </div>
            {!isDesktop && summary}
          </>
          : checkPrice?.status === STATUS.failed
            ? <Error />
            : <Loading middleOfPage />}
      </div>

      {isDesktop && <div className='orderInfo__aside__wrapper'>
        <div className='orderInfo__aside'>
          {summary}
        </div>
        <OrderDetailsInfo />
      </div>}
    </>
  )
}

const OrderDetailsInfo = () => {
  const { id } = useParams<{ id: string }>()
  const data = useReduxSelector(state => selectBasketItem(state, id))

  const { replace } = useHistory()
  const { t } = useTranslation('basket')

  if (data) {
    return (
      <div className='orderInfo__aside__info'>
        <div className='orderInfo__aside__info__left'>
          <i className='icon icon--pin-drop' />
          <b>{data.address?.city}, {t('st')}{data.address?.street} {data.address?.estateNumber}{data.address?.localNumber ? `/${data.address.localNumber}` : ''}</b>
        </div>
        <button
          className='button --back --link'
          onClick={() => {
            replace('/home')
          }}>
          <span>{t('chooseAnother')}</span>
        </button>
      </div>
    )
  }

  return null
}

export default OrderDetails